module.exports = __webpack_public_path__ + "static/img/scsz.6207f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scsz.png
// module id = bTX4
// module chunks = 1